export const aboutData = {
  brand: {
    name: '蜜桃tv',
    slogan: '精选好内容，温暖每一刻',
    founded: '2019年',
    description: `蜜桃tv成立于2019年，是一家专注于精选视频内容分发的互联网平台。我们致力于为用户提供高品质的视频观看体验，汇聚海内外优质影视、综艺、动漫、纪录片、短视频等多元化内容，让每一位用户都能在这里找到自己喜爱的节目。

平台以"精选好内容，温暖每一刻"为核心理念，通过专业的编辑团队和智能推荐算法，从海量视频内容中甄选出最具品质与观赏性的作品。我们相信，好的内容能够跨越时间和空间的界限，带给人们精神上的滋养与愉悦。

截至目前，蜜桃tv已累计服务超过5000万用户，日均活跃用户超过800万，涵盖视频内容超过10万部，总播放量突破100亿次。`,
    values: [
      {
        title: '精选品质',
        description: '专业编辑团队精心筛选，只推荐值得一看的好内容。',
        icon: 'ri-star-line',
      },
      {
        title: '用户至上',
        description: '一切以用户体验为核心，持续优化播放流畅度与界面交互。',
        icon: 'ri-heart-line',
      },
      {
        title: '内容多元',
        description: '影视、综艺、动漫、纪录片、短视频全覆盖，满足各类用户需求。',
        icon: 'ri-stack-line',
      },
      {
        title: '创新驱动',
        description: '运用AI推荐技术，为每位用户打造个性化的内容发现体验。',
        icon: 'ri-lightbulb-line',
      },
    ],
  },
  milestones: [
    { year: '2019', title: '创始之年', description: '蜜桃tv正式成立，推出网页版视频平台，首批上线5000部精选内容。' },
    { year: '2020', title: '快速发展', description: '用户突破1000万，上线App客户端，新增短视频和直播频道。' },
    { year: '2021', title: '内容升级', description: '与多家顶级内容方达成合作，引进超2万部正版影视作品。' },
    { year: '2022', title: '技术突破', description: '自研智能推荐系统上线，播放流畅度提升60%，用户留存率翻倍。' },
    { year: '2023', title: '生态构建', description: '推出创作者扶持计划，入驻创作者超5000人，形成完善的内容生态。' },
    { year: '2024', title: '行业领军', description: '累计用户突破5000万，日均播放量超1.5亿次，位居行业前三。' },
  ],
  testimonials: [
    {
      content: '蜜桃tv的推荐算法太懂我了，每次打开都能发现喜欢的内容，已经成为我每天必刷的平台。',
      author: '小陈同学',
      role: '忠实用户 · 使用3年',
    },
    {
      content: '作为内容创作者，蜜桃tv给了我们很好的展示平台和收益分成，让好内容能够被更多人看到。',
      author: '光影志',
      role: '认证创作者',
    },
    {
      content: '播放流畅不卡顿，画质清晰，界面简洁美观，蜜桃tv是我用过最好的视频平台之一。',
      author: '北方的狼',
      role: 'VIP会员 · 使用2年',
    },
    {
      content: '纪录片频道的内容真的太赞了！很多小众优秀的纪录片在其他平台根本找不到。',
      author: '好奇心日报',
      role: '纪录片爱好者',
    },
  ],
  contact: {
    address: '北京市朝阳区望京科技园区A座16层',
    phone: '400-888-6666',
    email: 'contact@mitao-tv.com',
    wechat: 'mitaotv_official',
    weibo: '@蜜桃tv官方',
    businessHours: '周一至周日 9:00 - 21:00',
  },
  faqs: [
    {
      question: '蜜桃tv如何保证视频播放的流畅度？',
      answer: '蜜桃tv采用全球分布式CDN加速网络，智能调度最优节点，确保全国用户都能获得流畅的高清播放体验。同时，我们的自适应码率技术会根据用户的网络状况实时调整画质，在保证流畅的前提下提供最佳的观看效果。',
    },
    {
      question: '蜜桃tv的内容是否都是正版的？',
      answer: '是的，蜜桃tv始终坚持正版原则，所有平台上的内容均经过正版授权。我们与国内外超过500家内容制作方和发行方建立了深度合作关系，确保用户观看的每一部作品都是合法合规的正版内容。',
    },
    {
      question: '如何成为蜜桃tv的VIP会员？',
      answer: '您可以通过蜜桃tv官方网站或App内的会员中心进行开通。我们提供月度、季度和年度三种会员方案，支持微信支付、支付宝等多种支付方式。VIP会员可享受无广告观看、超清画质、独家内容等专属权益。',
    },
    {
      question: '创作者如何入驻蜜桃tv平台？',
      answer: '欢迎优秀的内容创作者加入蜜桃tv！您可以在官网底部的"创作者入驻"入口提交申请，我们的内容运营团队将在7个工作日内完成审核。通过审核后，您即可上传作品并享受平台的流量扶持和收益分成。',
    },
  ],
};